import {
  SET_PATHSTOPS,
  RESET_PATHSTOPS,
  PathStopActionTypes,
} from "./pathStops.Actions";

const initialState = { pathStops: [] };

const PathStopsReducer = (
  state = initialState,
  action: PathStopActionTypes
) => {
  switch (action.type) {
    case SET_PATHSTOPS:
      return {
        // Need this setup for testing
        pathStops: action && action.payload ? [...action?.payload] : [],
      };
    case RESET_PATHSTOPS:
      return {
        pathStops: [],
      };
    default:
      return state;
  }
};

export default PathStopsReducer;
